var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.125C10 6.13588 10.7902 4.22822 12.1967 2.8217C13.6032 1.41518 15.5109 0.625 17.5 0.625C19.4891 0.625 21.3968 1.41518 22.8033 2.8217C24.2098 4.22822 25 6.13588 25 8.125C25 10.1141 24.2098 12.0218 22.8033 13.4283C21.3968 14.8348 19.4891 15.625 17.5 15.625C15.5109 15.625 13.6032 14.8348 12.1967 13.4283C10.7902 12.0218 10 10.1141 10 8.125ZM10 19.375C7.5136 19.375 5.12903 20.3627 3.37087 22.1209C1.61272 23.879 0.625 26.2636 0.625 28.75C0.625 30.2418 1.21763 31.6726 2.27252 32.7275C3.32742 33.7824 4.75816 34.375 6.25 34.375H28.75C30.2418 34.375 31.6726 33.7824 32.7275 32.7275C33.7824 31.6726 34.375 30.2418 34.375 28.75C34.375 26.2636 33.3873 23.879 31.6291 22.1209C29.871 20.3627 27.4864 19.375 25 19.375H10Z",
    fill: "#004025"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.06ff5c70d05e025dcbd4f9966e3bd008.svg";
export { ForwardRef as ReactComponent };